import { translate } from "lib/blocs/TranslateionBloc";
import useQuestionnaireCubitInContext from "src/state/QuestionnaireCubit/useQuestionnaireCubitInContext";
import Translate from "../Translate/Translate";
import { useNavigate } from "react-router-dom";
import { getErrorConfig, ErrorStateConfig } from "./errorStateConfig";
import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 3rem 1rem 0;
  max-width: ${APP_CONTENT_WIDTH_WITHOUT_PADDING}px;
  margin: 0 auto;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

const ErrorStateRenderer: React.FC<{
  config: ErrorStateConfig;
  error: string;
  navigate: (path: string) => void;
}> = ({ config, error, navigate }) => {
  const {
    icon: IconComponent,
    title,
    description,
    buttonText,
    buttonTheme,
    navigateTo,
    hideArrow,
    showContactInfo = false
  } = config;

  return (
    <Wrapper>
      {IconComponent && (
        <IconWrapper>
          <IconComponent size={60} />
        </IconWrapper>
      )}

      <h4>
        {translate(title, {
          context: error
        })}
      </h4>

      <p className="m2">
        <Translate msg={description} />

        {showContactInfo && (
          <>
            {" "}
            <a
              href="tel:+12029329958"
              style={{ color: "#000", fontWeight: "500" }}
            >
              (202) 932-9958
            </a>
            .
            <br />
            <Translate msg="help.emailSupport" />{" "}
            <a
              href="mailto:support@join9am.com"
              style={{ color: "#000", fontWeight: "500" }}
            >
              support@join9am.com
            </a>
            <br />
            <Translate msg="help.thankYouMessage" />
          </>
        )}
      </p>

      <Button
        center
        onPress={() => navigate(navigateTo)}
        hideArrow={hideArrow}
        theme={buttonTheme}
      >
        <Translate msg={buttonText} />
      </Button>
    </Wrapper>
  );
};

/**
 * Component responsible for rendering different questionnaire states:
 * - Loading states
 * - Error states (specific and generic)
 * - Handles state transitions and user navigation
 */
export const QuestionnaireStateRenderer = () => {
  const [questionnaireState] = useQuestionnaireCubitInContext();
  const navigate = useNavigate();

  if (questionnaireState.error) {
    const errorConfig = getErrorConfig(questionnaireState.error);

    return (
      <ErrorStateRenderer
        config={errorConfig}
        error={questionnaireState.error}
        navigate={navigate}
      />
    );
  }

  return null;
};
